import Service 			from "./../../Libs/Service";

let Access = new Service({

	Name: "Access",

	Events: {

	},

	Actions: {

	},

	init() {

	},

	check(accessCodename) {

		return User.currentUser.options?.access?.[accessCodename];

	}

});

window.Access = Access;

export { Access }

